module.exports = __webpack_public_path__ + "static/media/tenant_id.14ec3651.jpg";